export default __webpack_public_path__ + "images/Kompoul-fence.webp";